import { render } from "./AdminViewRequest.vue?vue&type=template&id=24a04b34"
import script from "./AdminViewRequest.vue?vue&type=script&lang=js"
export * from "./AdminViewRequest.vue?vue&type=script&lang=js"

import "./AdminViewRequest.vue?vue&type=style&index=0&id=24a04b34&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__